import type { AssumableAdminRole } from 'src/auth/types';

import useSWR from 'swr';
import { useMemo } from 'react';

import { fetcher, endpoints } from 'src/lib/axios';

import { useAuthContext } from 'src/auth/hooks';

export function useGetManagedAdminRoles() {
  const { assumedRoleId } = useAuthContext();

  const url = assumedRoleId ? endpoints.admin.management.managedAdminRoles(assumedRoleId) : null;

  const { data, isLoading, error, isValidating, mutate } = useSWR<AssumableAdminRole[]>(
    url,
    fetcher
  );

  return useMemo(() => {
    const roles = data ?? [];

    return {
      managedAdminRoles: roles,
      managedAdminRolesLoading: isLoading,
      managedAdminRolesError: error,
      managedAdminRolesValidating: isValidating,
      managedAdminRolesEmpty: !isLoading && roles.length === 0,
      managedAdminRolesRefresh: mutate,
      hasAssumedRole: assumedRoleId !== null,
    };
  }, [data, error, isLoading, isValidating, mutate, assumedRoleId]);
}
